import { Injectable } from '@angular/core'
import { environment } from '../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../models/response.model'

@Injectable({ providedIn: 'root' })
export class SugestaoAgrupamentoService {
  private baseUrl = environment.baseUrl
  private resource = 'SugestaoAgrupamento'

  constructor(private httpClient: HttpClient) {}

  public gerar(
    contratoId: any,
    janelaMinutos: number,
    agruparPorOrigem: boolean,
    agruparPorDestino: boolean,
    agruparPorVoo: boolean,
    modoAgrupamento = 0,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(`${this.baseUrl}${this.resource}/gerar/${contratoId}`, {
      janelaMinutos,
      agruparPorOrigem,
      agruparPorDestino,
      agruparPorVoo,
      modoAgrupamento,
    })
  }

  public confirmar(
    contratoId: any,
    grupos: {
      itemPropostaId: number
      passageiroIds: string[]
      observacao?: string | null
    }[],
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(`${this.baseUrl}${this.resource}/confirmar/${contratoId}`, {
      grupos,
    })
  }

  public moverPassageiro(payload: {
    passageiroId: string
    itemOrigemId: string
    itemDestinoId: string
  }): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(`${this.baseUrl}${this.resource}/mover-passageiro`, payload)
  }

  public removerPassageiro(payload: {
    passageiroId: string
    itemContratoId: string
  }): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(`${this.baseUrl}${this.resource}/remover-passageiro`, payload)
  }
}
